"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AzureRouting = void 0;
var _react = _interopRequireDefault(require("react"));
var _msalReact = require("@azure/msal-react");
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _DefaultLogin = require("./DefaultLogin");
var _Types = require("../Types");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Azure wrap
 *
 * @param {Element: required} children content
 * @param {Required} authFile File to set login settings, if null - default auth file for local development is used
 * @param {JSX.Element} loginComponent Custom login page, only as a Tag
 *
 * @returns {JSX.Element}
 *
 * @private
 */
const AzureRouting = _ref => {
  let {
    children,
    authFile = null,
    loginComponent
  } = _ref;
  const location = (0, _reactRouterDom.useLocation)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_msalReact.AuthenticatedTemplate, null, children), /*#__PURE__*/_react.default.createElement(_msalReact.UnauthenticatedTemplate, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Routes, {
    location: location
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "login",
    element: loginComponent || /*#__PURE__*/_react.default.createElement(_DefaultLogin.DefaultLogin, {
      authFile: authFile
    })
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "*",
    element: loginComponent || /*#__PURE__*/_react.default.createElement(_DefaultLogin.DefaultLogin, {
      authFile: authFile
    })
  }))));
};
exports.AzureRouting = AzureRouting;
AzureRouting.propTypes = {
  children: _propTypes.default.element.isRequired,
  authFile: _Types.AuthFileType,
  loginComponent: _propTypes.default.element
};
AzureRouting.defaultProps = {
  authFile: null,
  loginComponent: null
};